// Spreadsheet-style cell cursor for read/act tables: arrows hop cell to cell, never into a cell.
// Typing on a cell with [data-grid-type] hands the key to that editor (replaces the whole value).
const cellsOf = (tr) => (tr ? [...tr.children].filter((c) => c.tagName === "TD") : []);
const isDataRow = (tr, n) => cellsOf(tr).length >= n && cellsOf(tr).length > 1;

export const focusCell = (td) => {
  if (!td) return;
  td.tabIndex = -1;
  td.focus({ preventScroll: true });
  td.scrollIntoView({ block: "nearest", inline: "nearest" });
};

const rowStep = (tr, dir, idx) => {
  let t = dir > 0 ? tr.nextElementSibling : tr.previousElementSibling;
  while (t && !isDataRow(t, idx + 1)) t = dir > 0 ? t.nextElementSibling : t.previousElementSibling;
  return t;
};

export const moveFrom = (td, dRow, dCol) => {
  const tr = td.parentElement;
  const idx = cellsOf(tr).indexOf(td);
  if (dRow) { const t = rowStep(tr, dRow, idx); if (t) focusCell(cellsOf(t)[idx]); return; }
  focusCell(cellsOf(tr)[idx + dCol]);
};

const MOVES = { ArrowUp: [-1, 0], ArrowDown: [1, 0], ArrowLeft: [0, -1], ArrowRight: [0, 1] };

export function gridKeyDown(e) {
  const t = e.target;
  if (t.closest?.("[data-grid-editing]")) return; // an open editor owns its keys
  const td = t.closest?.("tbody td");
  if (!td) return;
  if (MOVES[e.key] || (e.key === "Tab")) {
    e.preventDefault();
    const [r, c] = e.key === "Tab" ? [0, e.shiftKey ? -1 : 1] : MOVES[e.key];
    moveFrom(td, r, c);
    return;
  }
  const typeTarget = td.querySelector("[data-grid-type]");
  const sel = td.querySelector("select:not(:disabled)");
  if (t !== td && (e.key === "Enter" || e.key === " ")) return; // a focused button/checkbox keeps its native behaviour
  if (e.key === "Enter") {
    e.preventDefault();
    if (sel) { try { sel.showPicker(); } catch { sel.focus(); } return; }
    td.querySelector("[data-grid-enter]:not(:disabled), input[type=checkbox]")?.click();
    return;
  }
  if (e.key === " " && td.querySelector("input[type=checkbox]")) { e.preventDefault(); td.querySelector("input[type=checkbox]").click(); return; }
  if (e.ctrlKey || e.metaKey || e.altKey) return;
  if (sel && e.key.length === 1) {
    e.preventDefault();
    const opt = [...sel.options].find((o) => o.value && o.text.toLowerCase().startsWith(e.key.toLowerCase()));
    if (opt && opt.value !== sel.value) { sel.value = opt.value; sel.dispatchEvent(new Event("change", { bubbles: true })); }
    return;
  }
  if (sel && (e.key === "Delete" || e.key === "Backspace")) {
    e.preventDefault();
    if (sel.value) { sel.value = ""; sel.dispatchEvent(new Event("change", { bubbles: true })); }
    return;
  }
  if (typeTarget && (e.key.length === 1 || e.key === "Delete" || e.key === "Backspace")) {
    e.preventDefault();
    typeTarget.dispatchEvent(new CustomEvent("grid-type", { detail: e.key }));
  }
}

// Clicking anywhere in a cell parks the cursor there (links/buttons still do their job).
export function gridMouseDown(e) {
  const td = e.target.closest?.("tbody td");
  if (!td || e.target.closest("input, select, textarea, [data-grid-editing]")) return;
  td.tabIndex = -1;
  if (!e.target.closest("button, a")) setTimeout(() => td.focus({ preventScroll: true }), 0);
}

export const gridNavProps = { onKeyDown: gridKeyDown, onMouseDown: gridMouseDown, className: "grid-nav" };
